import React, { useEffect, useState } from 'react';
import "./home.css"
import './recharge.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import GameHeader from '../header/header';
import { toast } from 'react-toastify';

const RechargePage = () => {
    let navigate = useNavigate();
    const [rechargeAmount, setRechargeAmount] = useState(0);
    const depositOptions = [50, 100, 200, 1000, 3000, 5000];
    const location = useLocation();
    const item = location.state;
    const handleRecharge = () => {
        if (rechargeAmount) {
            navigate('/Support')
        } else {
            toast.warning("Please Enter Recharge Amount")
        }
        // alert(`Recharge of USDC ${rechargeAmount} initiated!`);
    };

    const calculateblnce = (price) => {
        const actualbalance = item?.rowData?.actualbalance || item?.userdata?.actualbalance
        debugger
        const balance = item?.userData?.balance || item?.userdata?.balance
        if (actualbalance) {
            const amount = (actualbalance - price);
            return amount.toFixed(2);
        } else {
            const amount = (balance - price);
            return amount.toFixed(2);
        }
    };
    return (
        <div className="obtibg">
            <GameHeader />
            <div className='p-lg-5'>
                {/* <div className="balance-box">
                    <p>Account Balance</p>
                    <h3>USDC {item?.userData?.balance}</h3>
                </div> */}
                <div className="balance-box mt-3">
                    <p>Account Balance</p>
                    <h1 className='text-white' style={{ fontWeight: '700' }}>USDC {(calculateblnce(item?.rowData?.price) || "0.00")}</h1>
                </div>
                <div className="section">
                    <p className="label">Deposit Amount</p>
                    <div className="deposit-grid">
                        {depositOptions.map((amount) => (
                            <button
                                key={amount}
                                className="deposit-btn"
                                onClick={() => setRechargeAmount(amount)}
                            >
                                USDC {amount}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="section">
                    <p className="label">Recharge Amount</p>
                    <input
                        type="number"
                        value={rechargeAmount}
                        className="recharge-input"
                        onChange={(e) => setRechargeAmount(Number(e.target.value))}
                    />
                </div>
                <div className='center p-3 '>
                    <button class="btn btn-scondary w-50 btn-lg " type="button" onClick={handleRecharge}>
                        Recharge
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RechargePage;